export function pixelsToPercentage(pixels: number, totalSize: number) {
    return (pixels / totalSize) * 100;
}

export const percentageToPixels = (percent: number, totalSize: number): number => {
    return (percent / 100) * totalSize;
};
